module.exports = __webpack_public_path__ + "img/amasito.50469f41.jpg";